import actions from './actions';
import authActions from '../auth/actions';

const initState = {
  campaigns: [],
  loadingCampaigns: false,
  savingCampaign: false,
  togglingCampaignId: null,
  activeCampaign: null,
  userResponded: false,
  userDismissedAt: null,
  submittingResponse: false,
};

export default function npsReducer(state = initState, action) {
  switch (action.type) {
    case authActions.CLEAR_STATES:
      return initState;
    case actions.FETCH_NPS_ADMIN_DATA:
      return {
        ...state,
        loadingCampaigns: true,
      };
    case actions.FETCH_NPS_ADMIN_DATA_SUCCESS:
      return {
        ...state,
        campaigns: action.payload,
        loadingCampaigns: false,
      };
    case actions.FETCH_NPS_ADMIN_DATA_ERROR:
      return {
        ...state,
        loadingCampaigns: false,
      };
    case actions.CREATE_NPS_CAMPAIGN:
    case actions.UPDATE_NPS_CAMPAIGN:
      return {
        ...state,
        savingCampaign: true,
      };
    case actions.CREATE_NPS_CAMPAIGN_SUCCESS:
    case actions.UPDATE_NPS_CAMPAIGN_SUCCESS:
      return {
        ...state,
        savingCampaign: false,
      };
    case actions.CREATE_NPS_CAMPAIGN_ERROR:
    case actions.UPDATE_NPS_CAMPAIGN_ERROR:
      return {
        ...state,
        savingCampaign: null,
      };
    case actions.SET_NPS_CAMPAIGN_ACTIVE:
      return {
        ...state,
        togglingCampaignId: action.payload.id,
      };
    case actions.SET_NPS_CAMPAIGN_ACTIVE_SUCCESS:
    case actions.SET_NPS_CAMPAIGN_ACTIVE_ERROR:
      return {
        ...state,
        togglingCampaignId: null,
      };
    case actions.FETCH_ACTIVE_NPS_SUCCESS:
      return {
        ...state,
        activeCampaign: action.payload.campaign,
        userResponded: Boolean(action.payload.responded),
        userDismissedAt: action.payload.dismissedAt || null,
      };
    case actions.SUBMIT_NPS_RESPONSE:
      return {
        ...state,
        submittingResponse: true,
      };
    case actions.SUBMIT_NPS_RESPONSE_SUCCESS:
      return {
        ...state,
        submittingResponse: false,
        userResponded: true,
      };
    case actions.SUBMIT_NPS_RESPONSE_ERROR:
      return {
        ...state,
        submittingResponse: false,
      };
    case actions.DISMISS_NPS_SUCCESS:
      return {
        ...state,
        userDismissedAt: action.payload,
      };
    default:
      return state;
  }
}
